import styled from "styled-components";

const BlueCheck = styled.i.attrs({ className: "far fa-check-circle" })`
  margin-right: 5px;
  color: ${({ theme }) => theme.colors.primary_turquoise()};
`;

export default BlueCheck;
